import React from 'react'
import { formatCampaign } from '../../../../utils/formatters'
import { CAMPAIGN_CATEGORY_NAMES } from '../../../../utils/constants'
import * as S from './styles'

export const INITIAL_VALUE = 0
export const ITEMS_PER_PAGE = 5

const formatPromotionLabels = (promotions) => {
  if (promotions.length === 1) {
    return promotions[0]
  }

  const lastElement = promotions.pop()
  return `${promotions.join(', ')} e ${lastElement}`
}

const formatPromotions = (promotions, type) => {
  const promotionData = promotions.map(promotion => ({
    category: CAMPAIGN_CATEGORY_NAMES[promotion.category],
    code: promotion?.code,
    value: formatCampaign[promotion.discountType](promotion.discountValue)
  }))
  const isCampaign = type === 'campaign'

  return formatPromotionLabels(
    promotionData.map(data => ` ${isCampaign ? data.category : data.code} (${data.value})`)
  )
}

const createClientPromotionMessage = (clientPromotions, type) => {
  const hasMultiple = clientPromotions.length > 1
  const formattedPromotions = formatPromotions(clientPromotions, type)

  const isCampaign = type === 'campaign'
  const noun = isCampaign ? 'campanha' : hasMultiple ? 'cupons' : 'cupom'
  const verb = hasMultiple ? 'são' : 'é'
  const exclusive = isCampaign ? `exclusiva${hasMultiple ? 's' : ''}` : `exclusivo${hasMultiple ? 's' : ''}`

  return (
    <S.clientCampaigns>
      Importante: {isCampaign ? 'A' : 'O'}{hasMultiple ? 's' : ''} {noun} {isCampaign ? 'de' : ''}{' '}
      <strong>{formattedPromotions}</strong> {verb} {exclusive} para visão{' '}
      <strong>Clientes (Agendamento Online Web/App).</strong>
    </S.clientCampaigns>
  )
}

const generatePromotionText = (sameDay, sameDate, items, type) => {
  const hasMultiple = items.length > 1
  const formattedItems = formatPromotions(items, type)
  const isCampaign = type === 'campaign'

  const noun = isCampaign ? 'campanha' : hasMultiple ? 'cupons' : 'cupom'
  const promoAdj = hasMultiple ? 'is' : 'l'
  const verb = hasMultiple ? 'estão' : 'está'
  const pastVerb = hasMultiple ? 'm' : ''
  const active = isCampaign ? `ativa${hasMultiple ? 's' : ''}` : `ativo${hasMultiple ? 's' : ''}`

  const clientItems = isCampaign
    ? items.filter(item => item.visibleTo?.length === 1 && item.visibleTo[0] === 'CLIENT')
    : items

  const clientMessage = sameDay && clientItems.length > 0
    ? createClientPromotionMessage(clientItems, type)
    : null

  const currentDateText = (
    <>
      Hoje <strong>{items.length} {noun}{isCampaign && hasMultiple ? 's' : ''} promociona{promoAdj}</strong> {verb} {active}:{' '}
      <strong>{formattedItems}</strong>. Alguns serviços realizados podem entrar no faturamento com o valor promocional.
      {clientMessage}
    </>
  )

  const pastDateText = (
    <>
      Nesse dia <strong>{items.length} {noun}{isCampaign && hasMultiple ? 's' : ''} promociona{promoAdj}</strong> estava{pastVerb} {active}:{' '}
      <strong>{formattedItems}</strong>. Alguns serviços realizados podem entrar no faturamento com o valor promocional.
    </>
  )

  return sameDate ? (sameDay ? currentDateText : pastDateText) : pastDateText
}

export const CAMPAIGN_TEXT = (sameDay, sameDate, campaigns) =>
  generatePromotionText(sameDay, sameDate, campaigns, 'campaign')

export const COUPON_TEXT = (sameDay, sameDate, coupons) =>
  generatePromotionText(sameDay, sameDate, coupons, 'coupon')
